import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import UserProfileForm from '@galo-monitor/web-containers/forms/common/UserProfileForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const UserProfileModal = (props) => {
  const {
    id,
    open,
    handleClose,
    user,
    languageOptions,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const { createDialog } = useDialog()
  const t = useT()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    response => {
      setLoading(false)
      createDialog({
        id: 'error-user-profile-modal',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'female',
            action: toLower(t('update')),
            this: toLower(t('password'))
          })  }.`,
          message: t(response?.data?.message ?? response?.data?.errors?.[0]?.message)
        }
      })
    },
    [createDialog, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('personal information', { howMany: 2 }) }
      maxWidth="xs"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <UserProfileForm
        ref={ formRef }
        user={ user }
        languageOptions={ languageOptions }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

UserProfileModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  user: PropTypes.object,
  languageOptions: PropTypes.array.isRequired
}

UserProfileModal.defaultProps = {
  user: {}
}

export default UserProfileModal
